export function replaceUnicodeSpaceWithAsciiSpace(input: string): string {
  return input.replace(/[\u00A0\u1680\u180e\u2000-\u2009\u200a\u200b\u202f\u205f\u3000]/g, " ")
}
